import { Util } from '@grandvisionhq/forms'

export const isPhoneNumber = (value: string): boolean => REGEX.PHONE_NUMBER.test(value)

export const isMobilePhoneNumber = (value: string): boolean => REGEX.MOBILE_PHONE_NUMBER.test(value)

export const isPostalCode = (value: string): boolean => REGEX.POSTAL_CODE.test(value)

export const isFiscalCode = (value: string): boolean =>
  REGEX.FISCAL_CODE.test(value.replace(/ /g, ''))

export const isIvaCode = (value: string): boolean => REGEX.IVA_CODE.test(value)

export const isStreetNumber = (value: string): boolean => REGEX.STREET_NUMBER.test(value)

const REGEX = {
  PHONE_NUMBER: /^(\+351|00351|351)?\d{9}$/,
  MOBILE_PHONE_NUMBER: /^(\+351|00351|351)([9]{1})(6|3|2|1{1})([0-9]{7})$/,
  POSTAL_CODE: /^\d{4}-\d{3}$/,
  FISCAL_CODE:
    /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
  IVA_CODE: /^\d{9}$/,
  STREET_NUMBER: /[0-9a-z]+$/i,
  ORDER_NUMBER: /^\d{7,10}$/, // supports order numbers with 7 to 10 digits
}

export const isOrderNumber: Util.validations.Validator = (value: string) =>
  REGEX.ORDER_NUMBER.test(value)

export const getTextLength = (text: string): number => {
  return text.length
}

const checkoutFieldsLengths: Record<string, number> & { default: number } = {
  fullName: 32,
  address_line_1: 32,
  default: 32,
  street: 32,
}

export const hasValidTextLength = (value: string, field: string): boolean => {
  const maxLength = checkoutFieldsLengths[field] ?? checkoutFieldsLengths.default
  return getTextLength(value) <= maxLength
}

export const isValidFullName = (input: string): boolean => {
  return Util.validations.isText(input) && hasValidTextLength(input, 'fullName')
}

export const isValidStreetName = (input: string): boolean => {
  return Util.validations.isStreetNameWithHouseNumber(input) && hasValidTextLength(input, 'street')
}

export const isValidStreetInfo = (input: string): boolean => {
  return Util.validations.isAddressLine(input) && hasValidTextLength(input, 'street')
}
